import { SetStateAction } from 'react';

export enum FlowBuilder2PageViewNameEnum {
  Builder = 'builder',
  Preview = 'preview',
}

export interface IFlowBuilder2PageContext {
  close: () => void;
  reload: () => void;
  isLoading: boolean;
  error: unknown;

  activeView: FlowBuilder2PageViewNameEnum;
  setActiveView: (activeView: SetStateAction<FlowBuilder2PageViewNameEnum>) => void;
}
